import { styled } from 'styled-components';

import { colors } from '#/theme/theme';

export const List = styled.ul`
  flex-wrap: wrap;
  list-style-type: none;
  padding-left: 0;
  color: ${colors.mediumContentGrey};

  li::before {
    content: '•';
    color: ${colors.brandBlue};
    display: inline-block;
    width: 1em;
  }
`;
